module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Topic List (Edit the topic to configure Label-Conversation Mapping)")]), _vm._v(" "), _c('div', {
    staticClass: "action-button pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.OpenPOP()
      }
    }
  }, [_vm._v("Add Topic")])]), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "Modal"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "400PX",
      "max-width": "600px"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Enter Topic")])]
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('form', {
      staticClass: "form-horizontal",
      attrs: {
        "action": "#",
        "method": "post"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.addNewMapping.apply(null, arguments)
        }
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label required",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("Topic Name")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.topic_name),
        expression: "topic_name"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': _vm.submitted && !_vm.$v.topic_name.required
      },
      attrs: {
        "type": "text",
        "id": "name",
        "placeholder": "New Topic Name"
      },
      domProps: {
        "value": (_vm.topic_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.topic_name = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.submitted && !_vm.$v.topic_name.required) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter topic name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label required",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "promptId"
      }
    }, [_vm._v("Prompt")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('nv-select', {
      staticClass: "form-control",
      class: {
        'form-group--error': _vm.submitted && !_vm.$v.promptId.required
      },
      attrs: {
        "id": "promptId"
      },
      model: {
        value: (_vm.promptId),
        callback: function($$v) {
          _vm.promptId = $$v
        },
        expression: "promptId"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Select a prompt--")]), _vm._v(" "), _vm._l((_vm.promptList), function(prompt) {
      return _c('option', {
        key: prompt.id,
        domProps: {
          "value": prompt.id
        }
      }, [_vm._v("\n                              " + _vm._s(prompt.prompt_name) + "\n                            ")])
    })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.promptId.required) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please select a prompt.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group pull-right"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.close
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "value": "Submit"
      }
    })])])])]
  })], 2)], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  })])]) : _vm._e()]), _vm._v(" "), (_vm.actionInProgress) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/loader/nivi-loader.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.columns,
      "rows": _vm.mappingData,
      "totalRows": _vm.mappingCount,
      "pagination-options": {
        enabled: true,
        perPage: 20
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'created_at') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                      ")]) : (props.column.field == 'edit') ? _c('span', [_c('router-link', {
          attrs: {
            "to": ("nlp_topic_detail?topicId=" + (props.row.id) + "&&topic_name=" + (props.row.topic) + "&&promptId=" + (props.row.prompt_id))
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1) : (props.column.field == 'delete') ? _c('span', [_c('i', {
          staticClass: "fa fa-times-circle",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteConfirmationPopup(props.index)
            }
          }
        })]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-list",
      "title": "No topic mappings found",
      "hint": "Try changing the filters."
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)])])])])])]), _vm._v(" "), (_vm.isDeleteConfirmationVisible) ? _c('deleteConfirmationModal', {
    attrs: {
      "isDeleteConfirmationVisible": _vm.isDeleteConfirmationVisible,
      "confirmationMessage": _vm.confirmationMessage,
      "actionToBePerformed": _vm.actionToBePerformed
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteNlpTopicMapping": _vm.deleteNlpTopicMapping
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      NLP Topics\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("NLP TOPIC Mappings")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Topic List")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-13398c2d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nlp-topic-mapping/nlpTopicMappingList.vue
// module id = wIgn
// module chunks = 1